interface BusinessTypesFromBackend {
    label: string;
    value: number;
}

interface DefinedBusinessTypes {
    label: string;
    value: number;
    description: string;
}

const businessTypeDescriptions: Record<string, string> = {
    "sole trader": "Also known as sole proprietorship. This is a registered business operated by one person.",
    "business starter": "A starter business is an unregistered small business that is in its early stages.",
    "registered company": "A registered company is any company that has officially registered its business i.e. Private Limited Liability Company (Ltd), Public Limited Company (PLC) Unlimited Company.",
    "incorporated trustees/ngo": "Any registered Charities, Religious Organizations, Board of Trustees, or Non-Profit making Organizations"
};

export const defineBusinessTypes = (
    businessTypes: BusinessTypesFromBackend[]
): DefinedBusinessTypes[] => {
    return businessTypes.map((type) => ({
        ...type,
        description: businessTypeDescriptions[type.label.toLowerCase()] || "No description available"
    }));
};